/* eslint-disable max-len */
import React from 'react';
function Roster() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z M16,20c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S18.2,20,16,20z M16.8,13h-1.5v1.7v1.7l1.5,0.9l1.5,0.9l0.8-1.3l-2.2-1.3V13z M4,18v-8h6.7C12.1,8.8,14,8,16,8c0.7,0,1.4,0.1,2,0.3V6 c0-1.1-0.9-2-2-2h-1V2h-2v2H7V2H5v2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h5.1c-0.4-0.6-0.6-1.3-0.8-2H4z" })));
}
export default Roster;
